module.exports = __webpack_public_path__ + "img/stress254-300x132.a77e51be.jpg";